import { useEffect } from 'react';

/**
 * onError is intentionally excluded from the effect deps so a changing callback
 * identity does not re-fire it.
 */
export const useMiniItemGate = ({
  bundleData,
  products,
  productsLoading = false,
  bundleLoading = false,
  error = null,
  onError = () => {}
}) => {
  const loading = productsLoading || bundleLoading;
  const renderMiniItem = bundleData && products?.length > 0 && !error;

  useEffect(() => {
    if (!loading && !renderMiniItem) {
      onError();
    }
  }, [renderMiniItem, loading]);

  return { loading, renderMiniItem };
};
